import React from 'react';
import { isMobile } from 'react-device-detect';
import ThemedLottie from '../../../../Shared/ThemedLottie/ThemedLottie';
import fiberNotFoundDesktop from './Animation/Fail_Desctop.json';
import fiberNotFoundMobile from './Animation/Fail_Mobile.json';
import './noFiberLead.scss';

const NoFiberLead = ({ subtitle }) => {
  const subtitleText = subtitle?.trim() || 'ניצור איתך קשר עם הצעה משתלמת';

  return (
    <div className='no-fiber-lead'>
      <div className='no-fiber-lead__content'>
        <h1 className='no-fiber-lead__title'>עדיין אין סיבים בכתובת שלך, מקווים להגיע בקרוב</h1>
        <p className='no-fiber-lead__subtitle'>{subtitleText}</p>
      </div>
      <div className={`no-fiber-lead__illustration${isMobile ? ' is-mobile' : ''}`}>
        <ThemedLottie
          animationData={isMobile ? fiberNotFoundMobile : fiberNotFoundDesktop}
          loop={false}
          autoplay={true}
          rendererSettings={{
            preserveAspectRatio: isMobile ? 'xMidYMid slice' : 'xMidYMid meet',
          }}
        />
      </div>
    </div>
  );
};

export default NoFiberLead;
